var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtmel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "&ns_svg;",
    width: 658.7480469,
    height: 335.4614258,
    viewBox: "0 0 658.7480469 335.4614258",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 658.7480469 335.4614258"
    },
    fill: "#006FAF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    x: -30.4960938,
    y: 254.8730469,
    height: 335.4614258,
    width: 658.7480469,
    bottomLeftOrigin: "true"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "609.0507813,335.4614258 626.2910156,297.4223633 0,297.4223633 0,335.4614258  609.0507813,335.4614258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "79.3647461,284.237793 79.3647461,254.3178711 65.1660156,254.3178711 94.5776367,205.8901367  94.5776367,284.237793 149.3442383,284.237793 149.3442383,83.9257813 101.6787109,83.9257813 2.2841797,284.237793  79.3647461,284.237793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "165.3222656,284.237793 165.3222656,66.6855469 106.4956055,66.6855469 144.5273438,0 658.2431641,0  658.2431641,66.6855469 214.5141602,66.6855469 214.5141602,284.237793 165.3222656,284.237793  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.0073242,284.237793V83.9257813h138.4438477c34.9931641,0,44.3710938,30.4326172,44.3710938,46.402832 V284.237793h-50.7109375c0,0,0-169.8793945,0-162.2729492c0,7.3500977,2.03125-12.1748047-6.3398438-12.1748047 c-0.5048828,0-9.6347656,0-9.6347656,0V284.237793h-49.1914063V108.0185547h-17.4931641V284.237793H232.0073242 L232.0073242,284.237793z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "429.2773438,284.237793 429.2773438,83.9257813 539.0673828,83.9257813 539.0673828,139.9667969  464.7763672,139.9667969 464.7763672,155.1791992 539.5761719,155.1791992 539.5761719,208.9360352 465.28125,208.9360352  465.28125,222.6254883 539.0673828,222.6254883 539.0673828,284.237793 429.2773438,284.237793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "554.2802734,284.237793 554.2802734,83.9257813 606.2617188,83.9257813 606.2617188,223.1313477  658.7480469,223.1313477 633.3925781,284.237793 554.2802734,284.237793  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmel);
export default __webpack_public_path__ + "static/media/Atmel.e9f395b9e2029a6bcef7aabbaaea6d2c.svg";
export { ForwardRef as ReactComponent };